export const PUBLIC_ROUTE_PREFIXES = [
  '/speak-your-skills',
  '/ler-terms',
  '/career-opportunities',
  '/next-steps',
];
